import {
  SELECT_BLOCKS,
  PLACE_BLOCK,
  GROUP,
  UNGROUP,
  UNDO,
  REDO,
  BLOCK_HOVER_IN,
  BLOCK_HOVER_OUT,
  SET_DRAG_OFFSET,
  COPY_BLOCKS,
  SET_CROP_BLOCK,
  SET_MODE
} from '../actionTypes'

import { LOCATION_CHANGE } from 'react-router-redux'
import {
  currentBoardBlocksSelector,
  editModeSelector
} from '../selectors/selectors'
import Rectangle from '../../utils/Rectangle'

export const selectBlocks = (blocks, multi) => (dispatch, getState) => {
  if (blocks === 'all') {
    blocks = Object.keys(currentBoardBlocksSelector(getState()))
  }
  dispatch({
    type: SELECT_BLOCKS,
    payload: { blocks, multi }
  })
}
export const setDragOffset = offset => ({
  type: SET_DRAG_OFFSET,
  payload: { offset }
})

export const setCropBlock = id => (dispatch, getState) => {
  if (!editModeSelector(getState())) return
  dispatch({ type: SET_CROP_BLOCK, payload: { id } })
}

export const blockHoverIn = id => ({ type: BLOCK_HOVER_IN, payload: { id } })
export const blockHoverOut = id => ({ type: BLOCK_HOVER_OUT, payload: { id } })

export const copyBlocks = blocks => ({ type: COPY_BLOCKS, payload: { blocks } })

const initialState = {
  selected: [],
  hovered: null,
  cropBlock: null
}

export const selectedBlocksReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case LOCATION_CHANGE:
    case SET_MODE:
      // deselect all
      return { ...state, selected: [] }
    case SET_DRAG_OFFSET:
      return { ...state, dragOffset: payload.offset }
    case SET_CROP_BLOCK:
      return { ...state, cropBlock: payload.id }
    case SELECT_BLOCKS:
      const { blocks, multi } = payload
      if (!blocks && !multi) {
        // deselect all
        return { ...state, selected: [] }
      } else if (!multi) {
        // select block, deselect others
        return { ...state, selected: blocks }
      } else {
        // multi-select. Toggle each block
        let selectedBlocks = [...state.selected]
        blocks.forEach(block => {
          const index = selectedBlocks.indexOf(block)
          if (index !== -1) {
            // deselect block
            selectedBlocks.splice(index, 1)
          } else {
            // add block to selection
            selectedBlocks.push(block)
          }
        })
        return { ...state, selected: selectedBlocks }
      }
    case COPY_BLOCKS:
      return {
        ...state,
        copiedBlocks: payload.blocks.map(block => ({
          ...block,
          layout: new Rectangle(block.layout)
        }))
      }
    case PLACE_BLOCK:
      // select new block if not an image
      if (!payload.block.image)
        return { ...state, selected: [payload.block.id] }
      return state
    case GROUP:
      // On group, select new group and forget that we might have been hovered on the old ID
      return { ...state, selected: [payload.groupId], hovered: null }
    case UNGROUP:
      // On ungroup, select blocks and forget that we might have been hovered on the old ID
      return {
        ...state,
        selected: payload.blocks.map(block => block.id),
        hovered: null
      }
    case BLOCK_HOVER_IN:
      return { ...state, hoveredBlock: payload.id }
    case BLOCK_HOVER_OUT:
      return { ...state, hoveredBlock: null }
    case UNDO:
      switch (payload.action && payload.action.type) {
        case PLACE_BLOCK:
          // select none
          return { ...state, selected: [] }
        case GROUP:
          // On undo group, select blocks
          return {
            ...state,
            selected: payload.action.payload.blocks.map(block => block.id)
          }
        case UNGROUP:
          // On undo ungroup, select new group
          return { ...state, selected: [payload.action.payload.groupId] }
        default:
          return state
      }
    case REDO:
      switch (payload.action && payload.action.type) {
        case PLACE_BLOCK:
          // select new block
          return { ...state, selected: [payload.action.payload.block.id] }
        case GROUP:
          // On group, select new group
          return { ...state, selected: [payload.action.payload.groupId] }
        case UNGROUP:
          // On ungroup, select blocks
          return {
            ...state,
            selected: payload.action.payload.blocks.map(block => block.id)
          }
        default:
          return state
      }
    default:
      return state
  }
}
